<template>
  <div>
    <scholarship-add-new
      :is-add-new-scholarship-sidebar-active.sync="isAddNewScholarshipSidebarActive"
      @refresh-data="() => { refScholarshipList.refreshData() }"
    />
    <list
      ref="refScholarshipList"
      sort-by="escolaridadId"
      :refetch-records="fetchScholarships"
      refetch-records-name="escolaridades"
      :actions="actions"
      key-field="escolaridadId"
      :table-columns="tableColumns"
      :table-actions="tableActions"
      :delete-method="deleteScholarship"
      :filters.sync="filters"
    />
  </div>
</template>
<script>
import { ref } from '@vue/composition-api'
import i18n from '@/libs/i18n'
import List from '@/components/List.vue'
import humanResources from '@/services/humanresources.service'
import ScholarshipAddNew from './ScholarshipAddNew.vue'

export default {
  components: {
    ScholarshipAddNew,
    List,
  },
  setup() {
    /* Refs */
    const refScholarshipList = ref(null)
    const isAddNewScholarshipSidebarActive = ref(false)
    /* Services */
    const { fetchScholarships, fetchScholarship, deleteScholarship } = humanResources()
    /* Data */
    const tableColumns = [
      {
        label: i18n.t('humanResources.scholarship.columns.scholarship'),
        key: 'nombre',
      },
      {
        label: i18n.t('humanResources.scholarship.columns.description'),
        key: 'descripcion',
      },
      {
        label: i18n.t('Lists.Actions'),
        key: 'actions',
      },
    ]
    const tableActions = ref([
      {
        name: 'edit',
        label: i18n.t('Lists.Edit'),
        aclAction: 'create',
        aclResource: 'Escolaridad',
        routeName: 'apps-human-resources-scholarship-edit',
        params: ['escolaridadId'],
        icon: 'CodepenIcon',
      },
      {
        name: 'delete',
        label: i18n.t('Lists.Delete'),
        aclAction: 'delete',
        aclResource: 'Escolaridad',
        params: ['escolaridadId'],
        icon: 'TrashIcon',
      },
    ])
    const actions = ref([
      {
        label: i18n.t('humanResources.scholarship.list.newScholarship'),
        aclAction: 'create',
        click: () => { isAddNewScholarshipSidebarActive.value = true },
        icon: 'PlusCircleIcon',
      },
    ])
    const filters = ref([])
    return {
      // Ref
      refScholarshipList,
      isAddNewScholarshipSidebarActive,
      tableColumns,
      tableActions,
      actions,
      filters,
      // API Calls
      fetchScholarships,
      fetchScholarship,
      deleteScholarship,
      // Params
      // searchQuery,
      // sortBy,
      // refetchScholarships,
      // isSortDirDesc,
      // Data
      // totalScholarship,
      // records,
      // UI
      // dataMeta,
      // Pagination
      // perPageOptions,
      // perPage,
      // currentPage,
      // status,
      // Event
      // refreshData,
    }
  },
}
</script>
<style lang="scss" scoped>

</style>
